import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-md-6" }
const _hoisted_2 = { class: "card scenario-card shadow-sm" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-10" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "fw-bold text-secondary" }
const _hoisted_7 = { class: "overflow-hidden" }
const _hoisted_8 = {
  key: 0,
  class: "card-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "card-content",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push(_ctx.route)))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _ctx.scenario?.patient_image?.location,
              class: "rounded-circle float-start",
              width: "75"
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.scenario?.patient_name), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString(_ctx.scenario.title), 1)
            ])
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-md-2 d-flex flex-column justify-content-center" }, [
            _createElementVNode("h3", { class: "text-center" }, [
              _createElementVNode("i", { class: "fas fa-arrow-circle-right text-primary" })
            ])
          ], -1))
        ])
      ]),
      (_ctx.scenario.credit_text)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "col-md-12 justify-content-end align-items-center" }, [
              _createElementVNode("div", { class: "text-success small me-4" }, "CREDIT AVAILABLE")
            ], -1)
          ])))
        : _createCommentVNode("", true)
    ])
  ]))
}